module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title\">\n        <i class=\"fas fa-exclamation-triangle\"></i> Unauthorized\n    </h4>\n</div>\n<div class=\"modal-body\">\n    <p>It seems your session has expired or your account has been suspended.</p>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"activeModal.close('signout')\">\n        <i class=\"fas fa-sign-out-alt\"></i>\n        Sign out\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modals/unauthorized.modal.html
// module id = 631
// module chunks = 1